import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()

export class AuthGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    public navCtrl: NavController
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return this.auth.isLogin().then(async (user: any) => {
        console.log('User Auth ->', user);
        if (user) {
          if (user.emailVerified) {
            return true;
          } else {
            this.navCtrl?.navigateRoot('/verify-email');
            return false;
          }
        } else {
          this.navCtrl?.navigateRoot('/login');
          return false;
        }
      });

  }


}
